import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-arih-blue text-white pt-16 pb-8" data-id="element-104">
      <div className="container mx-auto px-4 md:px-8" data-id="element-105">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-106">
          {/* Left Column - Logo & Text */}
          <div className="md:col-span-6 lg:col-span-5" data-id="element-107">
            <img src="https://cdn.magicpatterns.com/uploads/x5LDHU8dDFWY9GtEKeqcMv/logo_ariha.png" alt="ARIH ASM Logo" className="h-16 object-contain mb-6" data-id="element-108" />
            <p className="text-white/90 text-[16px] leading-relaxed max-w-sm" data-id="element-109">
              Association Régionale de l'Industrie Hôtelière Agadir Souss Massa.
              Engagée pour l'excellence et le développement du secteur
              touristique dans notre région.
            </p>
          </div>

          {/* Middle Column - Arih Links */}
          <div className="md:col-span-3 lg:col-span-3 lg:col-start-7" data-id="element-110">
            <h4 className="text-[20px] font-bold mb-6" data-id="element-111">Arih</h4>
            <ul className="space-y-4" data-id="element-112">
              <li data-id="element-113">
                <a href="/membres-ca" className="text-white/80 hover:text-white transition-colors" data-id="element-114">
                  Membres CA
                </a>
              </li>
              <li data-id="element-115">
                <a href="/statuts" className="text-white/80 hover:text-white transition-colors" data-id="element-116">
                  Statuts
                </a>
              </li>
              <li data-id="element-117">
                <a href="/comment-adherer" className="text-white/80 hover:text-white transition-colors" data-id="element-118">
                  Comment Adhérer
                </a>
              </li>
            </ul>
          </div>

          {/* Right Column - Quick Links */}
          <div className="md:col-span-3 lg:col-span-3" data-id="element-119">
            <h4 className="text-[20px] font-bold mb-6" data-id="element-120">Quick Link</h4>
            <ul className="space-y-4" data-id="element-121">
              <li data-id="element-122">
                <a href="/" className="text-white/80 hover:text-white transition-colors" data-id="element-123">
                  Home
                </a>
              </li>
              <li data-id="element-124">
                <a href="https://drive.google.com/file/d/1ioRzrd6QiBd9lpO7WHi5FrwFUeApChjX/view" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors" data-id="element-125">
                  Établissements
                </a>
              </li>
              <li data-id="element-126">
                <a href="/news" className="text-white/80 hover:text-white transition-colors" data-id="element-127">
                  News
                </a>
              </li>
              <li data-id="element-128">
                <a href="/evenements" className="text-white/80 hover:text-white transition-colors" data-id="element-129">
                  Évènements
                </a>
              </li>
              <li data-id="element-130">
                <a href="/emploi" className="text-white/80 hover:text-white transition-colors" data-id="element-131">
                  Emploi
                </a>
              </li>
              <li data-id="element-132">
                <a href="/formation" className="text-white/80 hover:text-white transition-colors" data-id="element-133">
                  Formation
                </a>
              </li>
              <li data-id="element-134">
                <a href="/contact-us" className="text-white/80 hover:text-white transition-colors" data-id="element-135">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 text-center" data-id="element-136">
          <p className="text-[14px] text-white/70" data-id="element-137">
            Association Régionale de l'Industrie Hôtelière Agadir Souss Massa -
            Tous droits réservés {currentYear}
          </p>
        </div>
      </div>
    </footer>;
}